import React, { Component, Fragment, createElement } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Card from "../../../shared/Card/Card";
import { NavLink } from "react-router-dom";
import { ROUTE_HOME } from "../../shared/constants";
import Loading from "../../../shared/Loading/Loading";
import InputCurrency from "../../../shared/InputCurrency/InputCurrency";
import Button from "../../../shared/button/button";
import { formatCurrency, intFormat } from "../../../../js/shared/utils";
import {
	formatDateToPortugueseFormat,
	formatDateToComputerDate,
	getUserToken
} from "../../shared/utils";
import {
	getOfferState,
	getOffers,
	getUserPayments,
	getRankByOfferId
} from "../../shared/requests-api";
import { editOffer, receiveOfferRank } from "../../actions";
import { withGetScreen } from "react-getscreen";
import { NationalAirlines } from "../../shared/enums";

let initialState = {
	simulation: false,
	simulationValue: null,
	simulationLoading: false,
	rank: 0
};

class RankingSimulator extends Component {
	constructor() {
		super();

		this.state = {
			initialState,
			handleMessage: false,
			enabled: true
		};
	}

	componentDidMount() {
		this.setState({ initialState });
	}

	componentWillReceiveProps(nextProps) {
		const { simulator, offersRank, receiveOfferRank } = nextProps;

		// Verifica se precisa buscar o ranking da oferta e então guarda no redux
		if (simulator && offersRank && simulator.id && !offersRank[simulator.id]) {
			let self = this;
			getRankByOfferId(getUserToken(), simulator.id).then(response => {
				let rank = response.data.rank;
				receiveOfferRank(simulator.id, {
					position: intFormat(rank.position) + "°",
					lastSaleDate: rank.lastSaleDate
				});
			});
		}
		this.setState({ initialState });
	}

	render() {
		const { loading, simulator, createNew, editOffer, offersRank, history, ...props } = this.props;

		const handleMessageFn = e => {
			this.setState({
				handleMessage: !this.state.handleMessage
			});
		};

		const onChangeFn = (str, val) => {
			let maxPrice = simulator.fidelity.maxPrice;
			let minPrice = simulator.fidelity.minPrice;
			let errorPrice = this.state.errorPrice;
			let enabled = this.state.enabled;

			if (maxPrice >= val && minPrice <= val) {
				enabled = true;
				errorPrice = "";
			} else {
				enabled = false;
				errorPrice = `O valor precisa estar entre ${formatCurrency(minPrice)} e ${formatCurrency(
					maxPrice
				)}`;
			}

			this.setState({ errorPrice, simulationValue: val, enabled: enabled, simulation: false });
		};

		const getOfferStateFn = () => {
			let { errorPrice, simulationValue } = this.state;

			if (!simulationValue) {
				errorPrice = "Campo obrigatório";
				this.setState({ errorPrice });
			} else if (!errorPrice) {
				this.setState({
					simulation: true,
					simulationLoading: true
				});
				getOfferState(null, simulator.fidelity.id, this.state.simulationValue, simulator.quant)
					.then(response => {
						this.setState({
							simulationLoading: false,
							rank: response.data.rank
						});
					})
					.catch(err => {
						this.setState({
							simulation: false,
							simulationLoading: false
						});
					});
			}
		};

		const editOfferFn = () => {
			const { offer, editOffer } = this.props;
			window.scrollTo(0, 0);
			// Não mostrar mais aviso
			localStorage.setItem("SimulatorMilesAviso", "1");

			this.setState({ simulationLoading: true });
			getOffers(getUserToken(), simulator.fidelity.id).then(response => {
				let offer = response.data.offers[0];

				if (!offer) {
					this.setState({
						simulation: false,
						simulationLoading: false
					});
				}

				offer.oldPrice = offer.price;
				offer.price = this.state.simulationValue;

				history.push(ROUTE_HOME);
				setTimeout(() => editOffer(offer), 50);
			});
		};

		const newOfferFn = () => {
			const { history, selected } = this.props;

			const airline = NationalAirlines[selected];

			if (airline) {
				localStorage.setItem("FidelityAcronym", airline.company.toLowerCase());
			}

			history.push(ROUTE_HOME);
		};

		let boxStyleButton = [];
		boxStyleButton.push("btn-gray-sm-o");

		const buttonSimulator = createElement(
			Button,
			{
				className: boxStyleButton.join(" "),
				disabled: !this.state.enabled,
				onClick: getOfferStateFn,
				"data-action": "ranking-simulator-simulate"
			},
			<span>Simular</span>
		);

		const buttonArrowMessage = createElement(
			Button,
			{
				className: "btn-green-md-label offers-ranking-page--message-button",
				onClick: handleMessageFn,
				"data-action": "ranking-simulator-message"
			},
			this.state.handleMessage ? <i className="icon-arrow-up" /> : <i className="icon-arrow-down" />
		);

		return (
			<Fragment>
				{!loading && Object.keys(simulator).length > 0 && simulator.quant ? (
					<Fragment>
						<h2 className="offers-ranking-page__title text-center pt-32">SIMULADOR DE PREÇO</h2>
						<p
							className="offers-ranking-page--p text-center font-size-small plr-16"
							style={{ maxHeight: this.state.handleMessage ? "100px" : "0px" }}
						>
							Você pode simular um <strong>novo</strong> preço para cada 1.000 milhas e checar a
							posição desta oferta no
							<br />
							ranking do programa de fidelidade.
						</p>
						{buttonArrowMessage}
					</Fragment>
				) : (
					<div className="pt-32" />
				)}

				<div className="offers-ranking-page__cards">
					{loading ? (
						<Loading />
					) : (
						<Card className="offers-ranking-page--no-border no-padding">
							{Object.keys(simulator).length > 0 && simulator.quant ? (
								<div className="offers-ranking-page__simulator">
									<div className="offers-ranking-page__simulator--first-row">
										<div className="offers-ranking-page__simulator--first-row--item">
											<p>Sua posição atual:</p>
											{!offersRank || !offersRank[simulator.id] ? (
												<Loading />
											) : (
												<strong>{offersRank[simulator.id].position}</strong>
											)}
										</div>
										<div className="offers-ranking-page__simulator--first-row--item">
											<p>Valor atual:</p>
											<strong>{formatCurrency(simulator.price)}</strong>
										</div>
										<div className="offers-ranking-page__simulator--first-row--item">
											<p>Qtd. de milhas:</p>
											<strong>{intFormat(simulator.quant)}</strong>
										</div>
										<div className="offers-ranking-page__simulator--first-row--item">
											<p>Última venda:</p>
											<strong>
												{offersRank[simulator.id] ? offersRank[simulator.id].lastSaleDate : "-"}
											</strong>
										</div>
									</div>
									<hr className="offers-ranking-page__simulator--hr" />
									<div className="offers-ranking-page__simulator--second-row">
										<div className="offers-ranking-page__simulator--second-row--item">
											<p>Simule um valor para cada 1.000 milhas:</p>
											<div className="offers-ranking-page--input-n-button">
												<InputCurrency
													onChange={(a, b) => onChangeFn(a, b)}
													value={this.state.simulationValue}
													decimalSeparator=","
													prefix="R$ "
													className="offers-ranking-page__simulator--input"
													placeholder="Valor"
													errorMessage={this.state.errorPrice}
													maxLength={4}
													data-action="ranking-simulator-value"
												/>
												{buttonSimulator}
											</div>
										</div>
										<div className="offers-ranking-page__simulator--second-row--item">
											{this.state.simulation ? (
												this.state.simulationLoading ? (
													<Loading />
												) : (
													<Fragment>
														<p className="font-weight-bold">Posição simulada:</p>
														<div className="offers-ranking-page--strong-n-button">
															<strong>{this.state.rank}º</strong>
															<Button
																onClick={editOfferFn}
																className="btn-primary-sm"
																disabled={this.state.errorPrice !== "" || simulator.status == 3}
																data-action="ranking-simulator-edit-offer"
															>
																Editar Oferta
															</Button>
														</div>
														{simulator.status == 3 && (
															<div
																className={
																	props.isMobile()
																		? "text-left"
																		: "offers-ranking-page__oferta-venda"
																}
															>
																A oferta está em venda.
															</div>
														)}
													</Fragment>
												)
											) : (
												<Fragment />
											)}
										</div>
									</div>
								</div>
							) : (
								<div className="row offers-ranking-page__create-new-offer">
									{this.props.isMobile() ? (
										<Fragment>
											<div className="col-xs-16 font-size-large">
												Você não possui oferta ativa cadastrada para este programa de fidelidade.
											</div>
											<div className="col-xs-16 text-right mt-16">
												<a
													className="btn btn-primary"
													onClick={newOfferFn}
													data-action="ranking-simulator-new-offer"
												>
													Nova oferta
												</a>
											</div>
										</Fragment>
									) : (
										<Fragment>
											<div className="col-xs-16 col-md-12 font-size-large">
												Você não possui oferta ativa cadastrada
												<br />
												para este programa de fidelidade.
											</div>
											<div className="col-xs-16 col-md-4 text-right">
												<a
													className="btn btn-primary"
													onClick={newOfferFn}
													data-action="ranking-simulator-new-offer"
												>
													Nova oferta
												</a>
											</div>
										</Fragment>
									)}
								</div>
							)}
						</Card>
					)}
				</div>
			</Fragment>
		);
	}
}

const mapStateToProps = state => ({
	offersRank: state.offers.ranks
});

const mapDispatchToProps = dispatch => {
	return {
		editOffer: offer => dispatch(editOffer(offer)),
		receiveOfferRank: (offerId, rank) => dispatch(receiveOfferRank(offerId, rank))
	};
};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(withGetScreen(RankingSimulator))
);
